// extracted by mini-css-extract-plugin
export default {"FAQsContainer":"PremierDeliveryFAQs_FAQsContainer","FAQsTitle":"PremierDeliveryFAQs_FAQsTitle","FAQsList":"PremierDeliveryFAQs_FAQsList"};